<template>
  <div>
    <form class="pt-4 pb-4">
      <div class="form-group">
        <label>Student number</label>
        <p>{{ content.studentNumber }}</p>
      </div>
      <div class="form-group">
        <label>Old Student number</label>
        <p>{{ content.oldStudentNumber }}</p>
      </div>
      <div class="form-group">
        <label>Student name</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input type="text" class="form-control" v-model="content.nameJp">
          <div class="error-text">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="form-group">
        <label>Student name (Alphabet)</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input type="text" class="form-control" v-model="content.name">
          <div class="error-text">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="form-group">
        <label>Nickname</label>
        <ValidationProvider v-slot="{ errors }">
          <input type="text" class="form-control" v-model="content.nickname">
          <div class="error-text">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <div class="form-group">
        <label>Student status</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <StudentStatusInput v-model="content.studentStatus" />
          <div class="error-text">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>
      <b-row>
        <b-col>
          <div class="form-group">
            <label>Email1</label>
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <input type="text" class="form-control w-75" v-model="content.email1">
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>Email2</label>
            <ValidationProvider rules="email" v-slot="{ errors }">
              <input type="text" class="form-control w-75" v-model="content.email2">
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label>Contact1</label>
            <ValidationProvider
              :rules="{ regex: /^[0-9\-\+ ]{0,256}$/ }"
              v-slot="{ errors }"
            >
              <input type="text" class="form-control w-75" v-model="content.phone1">
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>Contact2</label>
            <ValidationProvider
              :rules="{ regex: /^[0-9\-\+ ]{0,256}$/ }"
              v-slot="{ errors }"
            >
              <input type="text" class="form-control w-75" v-model="content.phone2">
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </b-col>
      </b-row>
    </form>
    <b-table
      v-if="content.courseHistories"
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="content.courseHistories"
      :fields="fields"
      :table-class="'list-table text-center mb-5'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    />
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { extend, ValidationProvider } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Datepicker from 'vuejs-datepicker';
import NationalityInput from '@/components/parts/inputItem/NationalityInput.vue';
import SelectPositionInput from '@/components/parts/inputItem/SelectPositionInput.vue';
import { Student, SpecialConsideration } from '@/store/students/types';
import StudentStatusInput from '@/components/parts/inputItem/StudentStatusInput.vue';

// バリデーションルール
extend('required', rules.required);
extend('required', { message: 'required.' });

extend('email', rules.email);
extend('email', { message: 'This is an incorrect or invalid email address.' });

extend('regex', rules.regex);
extend('regex', { message: 'Please enter a phone number with hyphen.' });

extend('regex', rules.regex);
extend('regex', { message: 'Please enter a phone number with hyphen.' });

extend('integer', rules.integer);
extend('integer', { message: 'Please enter a {_field_} must be a number.' });

@Component({
  components: {
    ValidationProvider,
    Datepicker,
    NationalityInput,
    SelectPositionInput,
    StudentStatusInput,
  },
})
export default class StudentInputForm extends Vue {
  @Prop() value!: Student|null

  @Prop() studentId?: string

  content: Object = {}

  fields: {key: String, label: String, formatter?: Function}[] = [
    {
      key: 'no',
      label: 'No',
    },
    {
      key: 'courseName',
      label: 'Course',
    },
    {
      key: 'specialConsiderations',
      label: 'Special consideration',
      formatter: (specialConsiderations: SpecialConsideration[]): string => {
        return specialConsiderations?.map((specialConsideration: SpecialConsideration) => {
          return specialConsideration.specialConsideration?.name;
        }).join(' , ')
      },
    },
  ]

  created() {
    if (this.$route.params.editingStudent) {
      // もし編集情報があるならそれを表示
      this.content = this.$route.params.editingStudent
    } else if (this.studentId) {
      // ID指定されている場合はIDを元に履修生情報取得
      this.$store.dispatch('getStudent', { studentId: this.studentId })
        .then(() => {
          const student: Student = _.cloneDeep(this.$store.getters.findStudentById(this.studentId))
          this.content = student
        })
    }
  }

  @Watch('content', { deep: true })
  noticeChange(content: Student) {
    this.$emit('input', content)
  }
}
</script>
